module.exports = __webpack_public_path__ + "img/SI.46f98c18.svg";